import { useState, useEffect } from 'react';
import { SIZES } from 'theme/sizes';
import { debounce } from 'utils/common';

export type Size = {
  width: number;
  height: number;
  isMobile?: boolean;
  isTablet?: boolean;
  isDesktop?: boolean;
  isWideDesktop?: boolean;
};

export const useWindowSize = (update = true): Size => {
  const [windowSize, setWindowSize] = useState<Size>({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const isMobile = windowSize.width <= SIZES.deviceSize.phone;
  const isTablet = windowSize.width <= SIZES.deviceSize.tablets;
  const isDesktop = windowSize.width < SIZES.deviceSize.desktop;
  const isWideDesktop = windowSize.width > SIZES.deviceSize.desktop;

  useEffect(() => {
    const type = 'resize';
    const listener = debounce(() => {
      if (!update) {
        return;
      }

      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    });

    window.addEventListener(type, listener);
    return () => window.removeEventListener(type, listener);
  }, [update]);

  return { ...windowSize, isMobile, isTablet, isDesktop, isWideDesktop };
};
